import { TComputedPropMapper } from '../../../types/computed-props-mapper';

export const isPro: TComputedPropMapper<boolean> = ({ offer }) => Boolean(offer.isPro);
